import Projection from 'ol/proj/Projection.js';
import '../../styles/attribution/attribution.scss';
import View from 'ol/View.js';
import {getCenter} from 'ol/extent.js';

//var extent = [0, 0, 2800, 1280];
var extent = [76.754142, 9.282574, 76.780787, 9.296956];
var imageSize = [1242, 674];

var projection = new Projection({
	code: 'xkcd-image',
	units: 'pixels',
	extent: extent,
	axisOrientation:'ene'
});

var view = new View({
  	projection: projection,
  	center: getCenter(extent),
  	extent: extent,
  	zoom: 2,
  	minZoom: 2,
  	maxZoom: 8
});

var target = 'beco-container';

function attributionHtml() {
  return '<a href="https://becoapp.in/" target="_blank"><img src="public/images/favicon.ico"></a> Map data ©'+ new Date().getFullYear() +' beCo <a href="https://becomap.com/terms/" class="copy-rights">Terms of Use</a> | <a class="copy-rights pop-up-click" data-toggle="modal" data-target="#myModal" onclick="return theFunction();">Report a map error</button>';
}

function toolbarConfig(props){

  let toolbar = {undo:true, redo:true};

  if (props.asset_tracking){
    toolbar['point'] = true;
  }

  if (props.navigation){
    toolbar['select'] = true ;
    toolbar['modify'] = true ;
    toolbar['line'] = true;
    
    toolbar['split']=true;
    
  }

  if(props.kiosk){
    toolbar['polygon'] = true;
  }else {
    toolbar['polygon'] = false;
  }

  return toolbar;
}


export { view, projection, extent , attributionHtml, target, imageSize, toolbarConfig };

// Ref https://hackernoon.com/import-export-default-require-commandjs-javascript-nodejs-es6-vs-cheatsheet-different-tutorial-example-5a321738b50f
// Ref https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export
